import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../store';

const BASE_API = process.env.REACT_APP_BASE_API;

interface IAnyResponse {
  [key: string]: any;
}

interface IRatingPayload {
  lang: string;
}

export const ratingSlice = createApi({
  reducerPath: 'rating',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_API,
    prepareHeaders: (headers, { getState, endpoint }) => {
      const token = (getState() as RootState).isAuth.isAuth;
      const lang = (getState() as RootState).language.lang;
      const publicEndpoints = ['getRating'];
      const isPublic = publicEndpoints.includes(endpoint);
      if (token && !isPublic) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set('Accept-Language', lang);
      return headers;
    }
  }),
  tagTypes: ['Rating'],
  endpoints: (builder) => ({
    getRating: builder.query<IAnyResponse, IRatingPayload>({
      query: (payload) => ({
        url: `/rating`,
        method: 'GET'
      })
    })
  })
});

export const { useGetRatingQuery } = ratingSlice;
